import { render, staticRenderFns } from "./TelegramChat.vue?vue&type=template&id=abc3e2a6"
import script from "./TelegramChat.vue?vue&type=script&lang=js"
export * from "./TelegramChat.vue?vue&type=script&lang=js"
import style0 from "./TelegramChat.vue?vue&type=style&index=0&id=abc3e2a6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports